import { render } from "./ContentPage.vue?vue&type=template&id=95e794da"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"

import "./ContentPage.vue?vue&type=style&index=0&id=95e794da&lang=scss"
script.render = render

export default script